export const Arguments = ({ }: {}) => {
    return (
        <>
            <section className="mt-14 lg:my-16">
                <div className="flex flex-col gap-4 px-3 md:w-[95%] lg:px-0 max-w-7xl mx-auto" data-aos="fade-up">
                    <div className="flex flex-col gap-2 mb-6 lg:mb-5">
                        <h2 className="font-bold text-3xl lg:text-2xl text-stone-700 text-center uppercase">Trouvez l'offre Fibre avec le meilleur rapport qualité-prix
                        </h2>
                    </div>

                    <div className="mb-5 w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-6">

                        <div
                            className="group flex flex-col justify-center items-center gap-4 border-slate-200 border rounded-lg lg:shadow overflow-hidden"
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            <p className="px-4 py-6 lg:py-8 text-2xl lg:text-xl lg:text-center font-medium">
                                Un forfait tout-en-un, flexible et sans engagement
                            </p>
                        </div>

                        <div
                            className="group flex flex-col justify-center items-center gap-4 border-slate-200 border rounded-lg lg:shadow overflow-hidden"
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            <p className="px-4 py-6 lg:py-8 text-2xl lg:text-xl lg:text-center font-medium">
                                Remboursement jusqu’à 100 € des frais de résiliation de votre ancien opérateur.
                            </p>
                        </div>

                        <div
                            className="group flex flex-col justify-center items-center gap-4 border-slate-200 border rounded-lg lg:shadow overflow-hidden"
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            <p className="px-4 py-6 lg:py-8 text-2xl lg:text-xl lg:text-center font-medium">
                                Installation rapide et activation en quelques jours seulement.
                            </p>
                        </div>
                    </div>
                    <div className="text-center w-full mt-5 lg:mt-6">
                        <a href="#top" className="bg-primaryNewComparateurFibre text-center text-white font-medium py-4 px-12 lg:py-5 hover:text-primaryNewComparateurFibre hover:border-primaryNewComparateurFibre hover:border-2 hover:font-bold hover:ease-linear hover:duration-300 hover:bg-white text-lg lg:text-xl rounded-full">COMPARER MAINTENANT !</a>
                    </div>
                </div>
            </section>
        </>
    );
};
